import { api } from '../utils/axios';

export const createImage = (userData) => async (dispatch) => {
  
  let data = {};
  delete userData['selected-app']
  delete userData['alt_image']
  data.target_image = userData;

  dispatch({
    type: "CREATE_IMAGES_REQUESTED"
  });
  try {
    const response = await api.post('admin/create_image', data);
    dispatch({
      type: "CREATE_IMAGES_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CREATE_IMAGES_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const getImages = (silent = false) => async (dispatch) => {
  
  let data = {};
  if(!silent) {
    dispatch({
      type: "GET_IMAGES_REQUESTED"
    });
  }
  try {
    const response = await api.post('admin/get_images', data);
    dispatch({
      type: "GET_IMAGES_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_IMAGES_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const updateImages = (userData, silent = false) => async (dispatch) => {
  
  let data = {};
  delete userData['selected-app']
  delete userData['session_banner'] 
  
  if (userData.session_banner === "") {
    userData.session_banner = null
  }
  data.target_image = userData;
  dispatch({
    type: "UPDATE_IMAGES_REQUESTED"
  });
  try {
    const response = await api.post('admin/update_image', data);
    dispatch({
      type: "UPDATE_IMAGES_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_IMAGES_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export function setImagesPageInfo({pageSize,pageNo}){
  return {
    type : 'SET_IMAGES_PAGEINFO',
    payload : {pageSize,pageNo }
  }
}

export const editWorkspace = (workspace, overrideChannel = null) => async (dispatch) => {
  dispatch({
    type: "EDIT_WORKSPACE",
    response: workspace,
    overrideChannel
  });
}

export const cloneImage = (imageId) => async (dispatch) => {
  let data = {};
  data.target_image = {"image_id": imageId};
  try {
    const response = await api.post('admin/duplicate_image', data);
    return { response }
  } catch (e) {
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);
  }
}

export const deleteImages = (imageId) => async (dispatch) => {
  
  let data = {};
  data.target_image = {"image_id": imageId};

  dispatch({
    type: "DELETE_IMAGES_REQUESTED"
  });
  try {
    const response = await api.post('admin/delete_image', data);
    dispatch({
      type: "DELETE_IMAGES_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DELETE_IMAGES_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const getServerCustomNetworkNames = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_SERVER_CUSTOM_NETWORK_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_server_custom_network_names', data);
    dispatch({
      type: "GET_SERVER_CUSTOM_NETWORK_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_SERVER_CUSTOM_NETWORK_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const getRegistries = () => async (dispatch) => {
  
  let data = {};
  dispatch({
    type: "GET_REGISTRIES_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_registries', data);
    dispatch({
      type: "GET_REGISTRIES_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_REGISTRIES_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const createRegistry = (registry, schema_override = null, channel = null) => async (dispatch) => {
  
  let data = {};
  data.registry = registry
  data.override_schema = schema_override
  data.channel = channel
  dispatch({
    type: "CREATE_REGISTRY_REQUESTED"
  });
  try {
    const response = await api.post('admin/create_registry', data);
    dispatch({
      type: "CREATE_REGISTRY_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CREATE_REGISTRY_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const updateRegistry = (registryId) => async (dispatch) => {
  
  let data = {};
  data.registry_id = registryId
  dispatch({
    type: "UPDATE_REGISTRY_REQUESTED"
  });
  try {
    const response = await api.post('admin/update_registry', data);
    dispatch({
      type: "UPDATE_REGISTRY_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_REGISTRY_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const registryAutoUpdate = ({registryId, auto_updates}) => async (dispatch) => {
  
  let data = {};
  data.registry_id = registryId
  data.auto_updates = auto_updates
  dispatch({
    type: "UPDATE_REGISTRY_REQUESTED"
  });
  try {
    const response = await api.post('admin/registry_auto_updates', data);
    dispatch({
      type: "UPDATE_REGISTRY_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_REGISTRY_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const registryChannel = ({registryId, channel}) => async (dispatch) => {
  
  let data = {};
  data.registry_id = registryId
  data.channel = channel
  dispatch({
    type: "UPDATE_REGISTRY_REQUESTED"
  });
  try {
    const response = await api.post('admin/registry_set_channel', data);
    dispatch({
      type: "UPDATE_REGISTRY_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_REGISTRY_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}





export const deleteRegistry = (registryId) => async (dispatch) => {
  
  let data = {};
  data.registry_id = registryId;
  dispatch({
    type: "DELETE_REGISTRY_REQUESTED"
  });

  try {
    const response = await api.post('admin/delete_registry', data);
    dispatch({
      type: "DELETE_REGISTRY_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DELETE_REGISTRY_FAILED",
      error: e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    });
    const errorMsg = e.error + (e.body && e.body.error_message ? ' - ' + e.body.error_message : '')
    throw new Error(errorMsg);

  }
}

export const rdpConnectionInfo = (options) => async (dispatch) => {
  let data = {};
  // Test iPhone and iPad, it's an assumption they need the fully encoded urls as well
  var needFullyEncodedUrl = /(Mac|iPhone|iPad)/i.test(navigator.userAgent);
  var needUrlOrDownload = /(Win|CrOS|Linux)/i.test(navigator.userAgent) ? 'download' : 'url';

  data = {
    kasm_id: options.kasmId,
    connection_type: needUrlOrDownload,
    fully_encoded: needFullyEncodedUrl
  }

  try {
    const response = await api.post('get_rdp_client_connection_info', data);
  
    return { response }
  } catch (e) {
  
    throw new Error(e.error);
  }

}

